 
import PropertyBreadcrumb from "../../commonComponents/breadcrumbs/PropertyBreadcrumb";
import SortBy from "../../commonComponents/SortBy";
import GridView from "../../commonComponents/gridView";

const Property2GridContainer = () => {
  return (
    <>
      <PropertyBreadcrumb />
      <SortBy />
      <GridView type="property" />
    </>
  );
};

export default Property2GridContainer;
